@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <!-- One flex row rather than pulling the controls up beside the title with a fixed left
    margin - the title is longer than any such margin, so the buttons sat on top of it. -->
    <div style="display:flex; align-items:center; flex-wrap:wrap; gap:8px; margin-bottom:20px;">
      <h3 style="margin:0 12px 0 0; white-space:nowrap;" i18n>Booking Calendar for</h3>
      <button pButton type="button" style="height: 50px; width: 53px;" (click)="dateChange(-7);" class="p-button-sm p-element p-ripple p-button p-component">
        <span class="pi pi-angle-double-left"></span>
      </button>
      <button pButton type="button" style="height: 50px; width: 53px;" (click)="dateChange(-1);" class="p-button-sm p-element p-ripple p-button p-component">
        <span class="pi pi-angle-left"></span>
      </button>
      <p-datepicker [selectOtherMonths]="true" [(ngModel)]="chosenDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="dateSelected()" (onInput)="dateSelected()" [inputStyle]="{'width':'130px'}"></p-datepicker>
      <button pButton type="button" style="height: 50px; width: 53px;" (click)="dateChange(1);" class="p-button-sm p-element p-ripple p-button p-component">
        <span class="pi pi-angle-right"></span>
      </button>
      <button pButton type="button" style="height: 50px; width: 53px;" (click)="dateChange(7);" class="p-button-sm p-element p-ripple p-button p-component">
        <span class="pi pi-angle-double-right"></span>
      </button>
      <button style="height: 50px;" pButton pRipple type="button" class="p-button-sm p-element p-ripple p-button p-component" (click)="loadgrid()" pTooltip="Refresh Data" tooltipPosition="bottom">
        <span class="pi pi-refresh"></span>
      </button>
      <p-selectbutton [options]="viewOptions" [(ngModel)]="calendarView" optionLabel="label" optionValue="value" (onChange)="viewChanged()" styleClass="bc-viewswitch"></p-selectbutton>
    </div>
    @if (bookingCount == 0) {
      <div style="width:100%">
        <p style="text-align:center; font-size:24px;">There are no bookings on this date.</p>
      </div>
    }
    <div class="surface-card p-4 shadow-2 border-round" style="margin-top:20px;">
      <full-calendar #bookingCalendar [options]="calendarOptions" deepChangeDetection="true"></full-calendar>
    </div>
  </div>
}
